mod.modules.define("IndustryAnalysis", "BaseModule", function (fn) {
    "use strict";

    var cache = {
        // DOM
        $tabs: null,
        $tabContent: null
    };

    fn.prototype.init = function (params) {
        this.base("init", params);

        cache.$tabs = this.el.find("ul.nav-tabs");
        cache.$tabContent = this.el.find("div.tab-content");

        var companyList = this.el.find('div.listCompanies-10');
        companyList.find('table').paginateTable({
            rowsPerPage: companyList.data("tablerows"),
            nextPage: "a[data-action=next]",
            prevPage: "a[data-action=prev]",
            totalPages: ".pageCount",
            pager: ".listCompanies-10 .pager-wrap"
        });
    };

    fn.prototype.loadHeatmap = function (e, $el) {
        var val = $el.val();
        var self = this;

        this.el.find("span.relativestrength-text").text(val == 1 ? "Trailing twelve months" : "Past " + val + " years");

        var loadData = { ChartYears: val };
        this.ajax(loadData, $.proxy(self.updateHeatmap, self));
    };

    fn.prototype.updateHeatmap = function (response) {
        if (response.html) {
        	this.el.find("div.chart-sprite").replaceWith(response.html);

        	var newTable = this.el.find("table.data");
	        newTable.find("tbody a[rel=tooltip]").tooltip();
			this.init(newTable);
        }
    };

    fn.prototype.events = {
        "select": {
            "change": function (e, $el) {
                this.loadHeatmap(e, $el);
            }
        },
        "ul.nav-tabs a": {
            "click": function (e, $el) {
                cache.$tabs.find("li.active").removeClass("active");
                $el.parent().addClass("active");

                var content = $el.data("target");
                cache.$tabContent.find("div.active").removeClass("active");
                cache.$tabContent.find(content).addClass("active");
            }
        }
    };

});